module.exports = __webpack_public_path__ + "assets/images/p2_b74b6116df9362abb4d6a05f4cfb801d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/packs/p2.png
// module id = 126
// module chunks = 0